module.exports = __webpack_public_path__ + "media/images/ui-icons_222222_256x240-9de1b0948e757a140d7797bd7f3e9072.png";